module.exports = __webpack_public_path__ + "img/barraFondoMobile.c04d38cb.svg";